<template>
  <b-row>
    <b-col>
      <b-row v-if="isLoading">
        <b-col>
          <Loader size="lg"></Loader>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col>
          <template>
            <b-row>
              <b-col>
                <div v-if="callLogData.rowsdata.length > 0">
                  <table class="table table-sm table-striped table-hover">
                    <thead>
                    <tr>
                      <th>{{ $t('global.day') }}</th>
                      <th>{{ $t('views.excmcalllog.list.answered') }}</th>
                      <th>{{ $t('views.excmcalllog.lastMonthReport.durationSum') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in callLogData.rowsdata" :key="item['@id']">
                      <td>
                        <span v-if="item.date">{{item.date}}</span>
                      </td>
                      <td>{{item.answered}} / {{item.quantity}}</td>
                      <td>{{ item.duration }}</td>
                    </tr>
                    <tr v-if="callLogData.rowsdata.length > 0 && callLogData.summary">
                      <td>{{ $t('views.agreements.form.total') }}</td>
                      <td>{{ callLogData.summary.totalAnswered }} / {{callLogData.summary.totalQuantity}}</td>
                      <td>{{ callLogData.summary.totalDuration }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <hr>
                  <CallLogChart :callLogData="callLogData"/>
                </div>
                <p v-else>{{ $t('views.excmcalllog.list.noItems') }} </p>
              </b-col>
            </b-row>
          </template>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../../Layout/Loader'
import getId from '@/utils/getIdFromLink'
import ApiService from '@/utils/ApiService'
import CallLogChart from '@/components/Dashboard/Views/excmcalllog/components/CallLogChart'

export default {
  name: 'CallLogLastMonthTable',
  data () {
    return {
      isLoading: true,
      callLogData: []
    }
  },
  components: { CallLogChart, Loader },
  props: {
    firmIRI: {
      type: String,
      default: null
    }
  },
  created () {
    this.fetchData()
  },
  beforeCreate () {
    checkPagePermission('firms', 'EXCMCallLogList')
  },

  methods: {
    async fetchData () {
      let params = { idRelatedUserData: getId(this.firmIRI) }
      this.callLogData = await new ApiService('reports/e_x_c_m_call_logs_last_month', params).getResults()
      this.isLoading = false
    }
  }
}
</script>
